module.exports = __webpack_public_path__ + "img/xiaoshuai.1438b3a9.png";